module.exports = __webpack_public_path__ + "static/img/device.92fbb78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device.png
// module id = b2Dn
// module chunks = 1